import React, { useRef } from 'react';
import '../Instagram.css';
import { Building2, Users, Wrench, PaintBucket, Shield, Clock, Leaf, Phone, Mail, MapPin, Heart, Star } from 'lucide-react';
import html2canvas from 'html2canvas';

const LOGO = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const downloadGraphic = async (elementId, filename) => {
  const el = document.getElementById(elementId);
  if (!el) return;
  const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: null });
  const link = document.createElement('a');
  link.download = filename + '.png';
  link.href = canvas.toDataURL('image/png');
  link.click();
};

const InstagramGraphics = () => {
  return (
    <div className="ig-page">
      <div className="ig-header">
        <img src={LOGO} alt="" className="ig-header-logo" />
        <h1>Grafiche Instagram — Colabella Group</h1>
        <p>Clicca "Scarica" su ogni grafica per salvarla. Formato 1080x1080px pronto per Instagram.</p>
      </div>

      {/* HIGHLIGHTS */}
      <h2 className="ig-section-title">Copertine Storie in Evidenza</h2>
      <div className="ig-highlights-row">
        {[
          { icon: Building2, label: 'CHI SIAMO' },
          { icon: Wrench, label: 'CANTIERI' },
          { icon: Star, label: 'PROGETTI' },
          { icon: PaintBucket, label: 'SERVIZI' },
          { icon: Heart, label: 'RECENSIONI' },
          { icon: Phone, label: 'CONTATTI' },
        ].map((h, i) => (
          <div key={i} className="ig-hl-wrap">
            <div className="ig-highlight" id={`hl-${i}`}>
              <h.icon size={40} />
              <span>{h.label}</span>
            </div>
            <button className="ig-dl-btn" onClick={() => downloadGraphic(`hl-${i}`, `highlight_${h.label.toLowerCase()}`)}>Scarica</button>
          </div>
        ))}
      </div>

      {/* POSTS */}
      <h2 className="ig-section-title">Post Instagram (1080x1080)</h2>
      <div className="ig-posts-grid">

        {/* Post 1 - Presentazione */}
        <div className="ig-post-wrap">
          <div className="ig-post" id="post-1">
            <div className="ig-post-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1080&q=80)' }} />
            <div className="ig-post-overlay ig-overlay-dark" />
            <div className="ig-post-content ig-center">
              <img src={LOGO} alt="" className="ig-post-logo" />
              <h2 className="ig-post-brand">COLABELLA<span>GROUP</span></h2>
              <div className="ig-post-line" />
              <p className="ig-post-tagline">Eccellenza nell'edilizia dal 1970</p>
              <p className="ig-post-small">Costruzioni • Ristrutturazioni • Edilizia</p>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-1', 'post_01_presentazione')}>Scarica Post 1</button>
        </div>

        {/* Post 2 - Storia */}
        <div className="ig-post-wrap">
          <div className="ig-post" id="post-2">
            <div className="ig-post-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1080&q=80)' }} />
            <div className="ig-post-overlay ig-overlay-dark" />
            <div className="ig-post-content ig-bottom-left">
              <p className="ig-post-pre">LA NOSTRA STORIA</p>
              <h2 className="ig-post-h2">Due generazioni.<br/>Una sola missione.</h2>
              <div className="ig-post-line" />
              <p className="ig-post-text">Fondata da Leo Colabella negli anni '70.<br/>Oggi guidata dal figlio Antonio.</p>
              <p className="ig-post-accent">50+ anni di passione</p>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-2', 'post_02_storia')}>Scarica Post 2</button>
        </div>

        {/* Post 3 - Cantiere */}
        <div className="ig-post-wrap">
          <div className="ig-post" id="post-3">
            <div className="ig-post-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1080&q=80)' }} />
            <div className="ig-post-overlay ig-overlay-gradient" />
            <div className="ig-post-content ig-bottom-left">
              <p className="ig-post-pre">CANTIERE IN CORSO</p>
              <h2 className="ig-post-h2">Ogni giorno,<br/>un passo avanti.</h2>
              <div className="ig-post-line" />
              <p className="ig-post-text">Precisione, dedizione e qualità<br/>in ogni fase del progetto.</p>
            </div>
            <div className="ig-post-badge">COLABELLA GROUP</div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-3', 'post_03_cantiere')}>Scarica Post 3</button>
        </div>

        {/* Post 4 - Servizi */}
        <div className="ig-post-wrap">
          <div className="ig-post ig-post-solid" id="post-4">
            <div className="ig-post-content ig-full-pad">
              <p className="ig-post-pre-dark">I NOSTRI SERVIZI</p>
              <h2 className="ig-post-h2-dark">Dalla A<br/>alla Z.</h2>
              <div className="ig-services-list">
                <div className="ig-svc"><Building2 size={20} /><span>Costruzioni Residenziali</span></div>
                <div className="ig-svc"><Wrench size={20} /><span>Ristrutturazioni</span></div>
                <div className="ig-svc"><Building2 size={20} /><span>Edilizia Commerciale</span></div>
                <div className="ig-svc"><PaintBucket size={20} /><span>Finiture di Pregio</span></div>
                <div className="ig-svc"><Shield size={20} /><span>Sicurezza e Conformità</span></div>
                <div className="ig-svc"><Clock size={20} /><span>Project Management</span></div>
              </div>
              <div className="ig-post-footer-dark">
                <img src={LOGO} alt="" style={{ width: 28, height: 28 }} />
                <span>COLABELLA GROUP</span>
              </div>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-4', 'post_04_servizi')}>Scarica Post 4</button>
        </div>

        {/* Post 5 - Prima Dopo */}
        <div className="ig-post-wrap">
          <div className="ig-post ig-post-split" id="post-5">
            <div className="ig-split-left" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1585128903994-9788298932a4?w=540&q=80)' }}>
              <span className="ig-split-label">PRIMA</span>
            </div>
            <div className="ig-split-right" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=540&q=80)' }}>
              <span className="ig-split-label">DOPO</span>
            </div>
            <div className="ig-split-center">
              <div className="ig-split-arrow">→</div>
            </div>
            <div className="ig-post-badge">COLABELLA GROUP</div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-5', 'post_05_prima_dopo')}>Scarica Post 5</button>
        </div>

        {/* Post 6 - Sostenibilità */}
        <div className="ig-post-wrap">
          <div className="ig-post" id="post-6">
            <div className="ig-post-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1518005020951-eccb494ad742?w=1080&q=80)' }} />
            <div className="ig-post-overlay ig-overlay-green" />
            <div className="ig-post-content ig-center">
              <Leaf size={48} color="#86efac" />
              <p className="ig-post-pre" style={{ color: '#86efac' }}>SOSTENIBILITÀ</p>
              <h2 className="ig-post-h2">Costruire<br/>responsabilmente.</h2>
              <div className="ig-post-line" style={{ background: '#86efac' }} />
              <p className="ig-post-text">Soluzioni eco-compatibili e materiali<br/>rigenerativi per un futuro migliore.</p>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-6', 'post_06_sostenibilita')}>Scarica Post 6</button>
        </div>

        {/* Post 7 - Team */}
        <div className="ig-post-wrap">
          <div className="ig-post" id="post-7">
            <div className="ig-post-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1080&q=80)' }} />
            <div className="ig-post-overlay ig-overlay-dark" />
            <div className="ig-post-content ig-bottom-left">
              <p className="ig-post-pre">IL NOSTRO TEAM</p>
              <h2 className="ig-post-h2">Il cuore<br/>dell'azienda.</h2>
              <div className="ig-post-line" />
              <p className="ig-post-text">Professionisti qualificati, uniti dalla<br/>passione per il lavoro ben fatto.</p>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-7', 'post_07_team')}>Scarica Post 7</button>
        </div>

        {/* Post 8 - Citazione */}
        <div className="ig-post-wrap">
          <div className="ig-post ig-post-quote" id="post-8">
            <div className="ig-post-content ig-center">
              <div className="ig-quote-mark">"</div>
              <h2 className="ig-quote-text">Non costruiamo<br/>solo edifici.<br/><span className="ig-quote-accent">Costruiamo<br/>il futuro.</span></h2>
              <div className="ig-post-line" />
              <div className="ig-post-footer-dark" style={{ justifyContent: 'center' }}>
                <img src={LOGO} alt="" style={{ width: 24, height: 24 }} />
                <span>COLABELLA GROUP — DAL 1970</span>
              </div>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-8', 'post_08_citazione')}>Scarica Post 8</button>
        </div>

        {/* Post 9 - Contatti */}
        <div className="ig-post-wrap">
          <div className="ig-post ig-post-contact" id="post-9">
            <div className="ig-post-content ig-full-pad">
              <img src={LOGO} alt="" className="ig-post-logo-sm" />
              <p className="ig-post-pre-dark">CONTATTACI</p>
              <h2 className="ig-post-h2-dark" style={{ fontSize: 36 }}>Hai un progetto<br/>in mente?</h2>
              <div className="ig-contact-list">
                <div className="ig-contact-row"><Phone size={22} color="#c9a84c" /><div><strong>Telefono</strong><br/>+39 320 271 1608</div></div>
                <div className="ig-contact-row"><Mail size={22} color="#c9a84c" /><div><strong>Email</strong><br/>info@colabella.it</div></div>
                <div className="ig-contact-row"><MapPin size={22} color="#c9a84c" /><div><strong>Sede</strong><br/>Via Alba 1, San Martino in Pensilis (CB)</div></div>
              </div>
              <div className="ig-contact-cta">PREVENTIVO GRATUITO</div>
            </div>
          </div>
          <button className="ig-dl-btn" onClick={() => downloadGraphic('post-9', 'post_09_contatti')}>Scarica Post 9</button>
        </div>

      </div>
    </div>
  );
};

export default InstagramGraphics;
